import {
  useStyle 
} from "@/classify"
import mapProduct from "@/util/mapProduct"
import SuggestedProduct from "./suggestedProduct"
import defaultClasses from "./suggestedProducts.module.css"

const SuggestedProducts = (props) => {
  const {
    limit = 5, onNavigate, products 
  } = props
  const classes = useStyle(defaultClasses, props.classes)

  const items = products.slice(0, limit).map((product) => (
    <li key={product.id} className={classes.item}>
      <SuggestedProduct
        {...mapProduct(product)}
        onNavigate={onNavigate}
      />
    </li>
  ))

  return <ul className={classes.root}>{items}</ul>
}

export default SuggestedProducts
